<template>
  <v-container style="max-width: 1024px">
    <h1 class="display-3 font-weight-light">Mon Projet</h1>
    <br/>
    <p>Avec les réponses aux questions suivantes, nos paysagistes pourront vous faire une proposition se rapprochant le plus de vos souhaits.</p>
    <br/>
    <v-stepper v-model="e6" vertical>

      <StepType :step="1" :current="e6" v-model="form.type" @change="done(2)"/>

      <StepGoal :step="2" :current="e6" v-model="form.goal" @change="done(3)"/>

      <StepStyle :step="3" :current="e6" v-model="form.style" @change="done(4)"/>

      <StepArea :step="4" :current="e6" v-model="form.area" @change="done(5)"/>

      <StepSunshine :step="5" :current="e6" v-model="form.sunshine" @change="done(6)"/>

      <StepGround :step="6" :current="e6" v-model="form.ground" @change="done(7)"/>

      <StepMore :step="7" :current="e6" v-model="form.more" @change="done(8)"/>

      <v-stepper-step :complete="e6 > 8" :step="8" :editable="false" color="success">
        Merci pour vos réponses.
      </v-stepper-step>

      <v-stepper-content :step="8">
        Vous allez être rediriger vers notre boutique en ligne.
        <br/>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import StepType from '../components/project/Type'
import StepGoal from '../components/project/Goal'
import StepStyle from '../components/project/Style'
import StepArea from '../components/project/Area'
import StepSunshine from '../components/project/Sunshine'
import StepGround from '../components/project/Ground'
import StepMore from '../components/project/More'

export default {
  components: { StepType, StepGoal, StepStyle, StepArea, StepSunshine, StepGround, StepMore },
  data: () => ({
    e6: 1,
    form: {
      type: '',
      goal: '',
      style: '',
      area: '',
      sunshine: '',
      ground: '',
      more: ''
    },
  }),
  methods: {
    done (step) {
      this.e6 = step
      // this.$vuetify.goTo(`#project-step-${step}`, {})
      if (step === 8) {
        localStorage.setItem('form-done', JSON.stringify(this.form))
        setTimeout(() => { this.$router.push('/shop') }, 4000)
      }
    }
  },
  mounted () {
    const options = {}
    this.$vuetify.goTo(0, options)
  }
}
</script>

<style scoped>
@media (min-width: 1904px) {
  .container {
    max-width: 1185px!important;
  }
}
</style>